import { useEffect, useRef } from 'react';
import { Disclaimer } from './Disclaimer';
import { Anchor, Scroller, Thread } from './styled';
/**
 * Basic functional thread view with automatic scroll and anchor.
 * Does not contain any messages
 */
export function AssistantThreadView(props) {
    const { children, dependency } = props;
    const anchorRef = useRef(null);
    const scrollerRef = useRef(null);
    useEffect(() => {
        var _a, _b, _c;
        (_a = scrollerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, (_c = (_b = anchorRef.current) === null || _b === void 0 ? void 0 : _b.offsetTop) !== null && _c !== void 0 ? _c : 0);
    }, [dependency]);
    return (<Scroller ref={scrollerRef}>
      <Thread>
        <Disclaimer />
        {children}
      </Thread>
      <Anchor ref={anchorRef}/>
    </Scroller>);
}
